export enum FeatureFlagKeys {
  AutoSubmitInsuranceClaim = "auto-submit-insurance-claim",
  // Gates the self-pay branch of processAppointmentInsuranceClaim (ENG-854).
  // Evaluated with the patient's id as distinctId so Prod can be canaried on
  // a single patient before a full rollout.
  AutoSubmitSelfPayClaim = "auto-submit-self-pay-claim",
  PhoneAppointmentScheduling = "phone_appointment_scheduling",
  PatientCancelAppointment = "patient-cancel-appointment",
  OnboardingSkipIntro = "onboarding-skip-intro",
  WriteCanvasEpisodeOfCare = "write_canvas_episode_of_care",
  ReadCanvasEpisodeOfCare = "read_canvas_episode_of_care",
  // EpisodeOfCare.prom
  ReadCanvasEocProm = "read_canvas_eoc_prom",
  // EpisodeOfCare.bodyRegion, EpisodeOfCare.diagnosis, EpisodeOfCare.assignedFollowUp, EpisodeOfCare.assignedFollowUpPerWeek
  ReadCanvasEocTriageField = "read_canvas_eoc_triage_field",
  // EpisodeOfCare.dischargeStatus, EpisodeOfCare.episodeComplete
  ReadCanvasEocDischargeStatus = "read_canvas_eoc_discharge_status",
  // EpisodeOfCare.appointments, EpisodeOfCare.soap
  ReadCanvasEocAppointments = "read_canvas_eoc_appointments",
  CanvasAppointmentListReads = "canvas-appointment-list-reads",
  // Enable-polarity: routes a patient to the Kemtai exercise list. A flag
  // missing from a stage's project therefore keeps that stage on the legacy
  // day-based UI rather than switching it to an untested path.
  KemtaiExercises = "kemtai-exercises",
  // Cuts appointment events over from the processCanvasAppointmentEvents
  // SQS consumer to the canvasWebHooks HTTP routes. Gates both sides.
  SyncAppointmentsEventUpdate = "sync_appointments_event_update",
  // New triages book the Evaluation note type (v2, no EOC).
  // Off or missing keeps the v1 Telehealth - Triage path.
  EvaluationNoteType = "evaluation-note-type",
  // Lets an existing patient book a new evaluation from the portal's Care plan.
  PortalBookEvaluation = "portal-book-evaluation",
  // Per-PT: offers that practitioner's new-style (virtual_evaluation) slots in
  // self-serve onboarding. Evaluated per canvasPractitionerId.
  PtNewStyleEvaluations = "pt-new-style-evaluations",
}

/**
 * Variant keys for the `onboarding-skip-intro` experiment, mirroring the
 * variants configured in PostHog. They have to match exactly: an unrecognised
 * value falls through to the control experience, which looks identical to a
 * working experiment that found no effect.
 */
export const ONBOARDING_SKIP_INTRO_VARIANTS = {
  control: "control",
  skipIntro: "skip-intro",
} as const;
